import {
  Dialog,
  Toolbar,
  Slide,
  Grid,
  DialogTitle,
  DialogContent,
  Typography,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";
import { ButtonSubmit } from "..";
import { useStyles } from "./BoxDialog.styles";
import { useIntl } from "react-intl";
import React, { useState } from "react";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
interface deleteAlertProps {
  alertClose: any;
  alertOpen: any;
  componentName: any;
  Submited: any;
  deletedValue: any;
  deletedDocumentData?: any;
  allDocumentsGroup?: any;
}
export const DeleteAlert = ({
  alertClose,
  alertOpen,
  componentName,
  Submited,
  deletedValue,
  deletedDocumentData,
  allDocumentsGroup,
}: deleteAlertProps) => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const [childpersent, setChildpersent] = React.useState(false);
  React.useEffect(() => {
    if (deletedDocumentData && allDocumentsGroup) {
      const checkChild = allDocumentsGroup.filter(
        (val) => val.parentId == deletedDocumentData.id
      );
      if (checkChild?.length) {
        setChildpersent(true);
      } else {
        setChildpersent(false);
      }
    }
  }, []);
  return (
    <div>
      <Dialog
        open={alertOpen}
        onClose={alertClose}
        TransitionComponent={Transition}
      >
        <DialogTitle id="alert-dialog-title" style={{ width: "100%" }}>
          {formatMessage({ id: componentName, defaultMessage: "Delete" })}
        </DialogTitle>
        <DialogContent>
          {childpersent ? (
            <Typography>
              {formatMessage({
                id: "documentchildDeletetext.message",
              })}
              &nbsp;
              <span style={{ color: "black", fontWeight: "bold" }}>
                {deletedValue}
              </span>
              &nbsp;
              {formatMessage({
                id: "documentchildDeletefolderName.message",
              })}
              <br />
              <br />{" "}
              {formatMessage({
                id: "documentchildDelete.message",
              })}
              <br />
            </Typography>
          ) : (
            <Grid container>
              <Typography
                variant="h6"
                className={
                  componentName === "form.clientAdmin"
                    ? classes.deleteMessage2
                    : classes.deleteMessage
                }
              >
                {componentName === "form.clientAdmin"
                  ? formatMessage({
                      id: "form.permissionDeleteMessage",
                      defaultMessage: "Are you sure you want to delete",
                    })
                  : formatMessage({
                      id: "group.user.delete.message",
                      defaultMessage: "Are you sure you want to delete",
                    })}
              </Typography>
              <Typography
                className={
                  componentName === "form.clientAdmin"
                    ? classes.deleteName2
                    : classes.deleteName
                }
              >
                {deletedValue}?
              </Typography>
            </Grid>
          )}
        </DialogContent>
        <Toolbar>
          <ButtonSubmit
            text={"form.no"}
            onClick={alertClose}
            className={classes.padding5}
          />
          <Grid container justifyContent={"flex-end"}>
            <ButtonSubmit text={"form.yes"} onClick={Submited} />
          </Grid>
        </Toolbar>
      </Dialog>
    </div>
  );
};
